import React from 'react'
import { Icon } from '../../../components/Polyfill';

import { Output } from '../../../Text'

const Heading = props => {
  let { originSystem, shoppingCart, stepper } = props;

  return (
    <>
      <div className="u-text-center">
        <Icon icon="semantic-checkmark" size="xxlarge" />
        <h2>
          {Output.resolveAsMarkdown(
            `pages.signatureSuccess.${originSystem}.title`
          )}
        </h2>
        <h3>
          {Output.resolveAsMarkdown(
            `pages.signatureSuccess.${originSystem}.subtitle`
          )}
        </h3>
      </div>
      {<div className='u-mt'>{shoppingCart}</div>}
      <div className="u-mt-large">
        {Output.resolve(
          `pages.signatureSuccess.${originSystem}.stepper.title`
        )}
        {stepper ? stepper : <></>}
      </div>
    </>
  )
}

export default Heading;
